import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import config from 'devextreme/core/config';
import ptMessages from './resources/pt-br/devexpressMessages';
import * as serviceWorker from './serviceWorker';
import { locale, loadMessages } from 'devextreme/localization';

class App extends Component {
	componentDidMount() {
		this.initMessages();
	}
	initMessages() {
		config({ thousandsSeparator: '.', decimalSeparator: ',' });

		locale('pt');

		loadMessages(ptMessages);
	}
	render() {
		return <Routes />;
	}
}

ReactDOM.render(<App />, document.getElementById('page'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
